<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fjDL1B/tc-custom/9780253022646.jpg?1713471321678" alt="This image is the cover for the book Eighteenth-Century Fortepiano Grand and Its Patrons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eighteenth-Century Fortepiano Grand and Its Patrons
      </h1>
      <p class="bookDescription body article font2">
        <b>“Badura-Skoda addresses the place of the piano in the eighteenth century from the perspective of a scholar and performer” (<i>Eighteenth-Century Music</i>).</b><br/><br/>In the late seventeenth century, Italian musician and inventor Bartolomeo Cristofori developed a new musical instrument—his <i>cembalo che fa il piano e forte</i>, which allowed keyboard players flexible dynamic gradation. This innovation, which came to be known as the hammer-harpsichord or fortepiano grand, was slow to catch on in musical circles. However, as renowned piano historian Eva Badura-Skoda demonstrates, the instrument inspired new keyboard techniques and performance practices and was eagerly adopted by virtuosos of the age, including Scarlatti, J. S. Bach, Clementi, Haydn, Mozart, and Beethoven. Presenting a rich array of archival evidence, Badura-Skoda traces the construction and use of the fortepiano grand across the musical cultures of eighteenth-century Europe, providing a valuable resource for music historians, organologists, and performers.<br/><br/><b>“Badura-Skoda has written a remarkable volume, the result of a lifetime of scholarly research and investigation. . . . Essential.” —<i>Choice</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eva Badura-Skoda
      </h2>
      
      <p class="authorDescription body article"><P>Eva Badura-Skoda, noted musicologist, publishes extensively on the history of the piano and on performance practices of the 18th and 19th centuries. She is author of The History of the Pianoforte: A Documentary in Sound and coauthor (with Paul Badura-Skoda) of Interpreting Mozart: The Performance of His Piano Works.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b5ccc176